import script from "./OperationSecondaryHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./OperationSecondaryHeader.vue?vue&type=script&setup=true&lang=js"

import "./OperationSecondaryHeader.vue?vue&type=style&index=0&id=f777bcdc&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f777bcdc"]])

export default __exports__